export const STRINGS = {
  variableFees: {
    item1: {
      name: 'Guaranteed Rent Payments',
      text: "We're so confident in our vetting process, that once we place Residents in your home, their rent payments are guaranteed regardless of if we’re able to collect.",
      options: ['Included', 'Unavailable'],
    },
    item2: {
      name: 'Eviction Protection',
      text: 'Situations can change, even for the best Residents. In those cases, Belong is there to handle the entire eviction process.',
      options: ['Up To $15k Included', 'Unavailable'],
    },
    item3: {
      name: 'Management Fee',
      options: ['', '8‑12% Of Rent'],
    },
    item4: {
      name: 'Placement Fee',
      options: ['', '100% Of 1st Month’s Rent'],
    },
    item5: {
      name: 'Lease Renewal Fee',
      options: ['', '$200‑1k'],
    },
  },
  fixedFees: {
    item1: {
      name: 'Guaranteed Rent & Eviction Protection',
      text: "We're so confident in our vetting process, that once we place Residents in your home, their rent payments are guaranteed regardless of if we’re able to collect. And while situations can change, even for the best of Residents, Belong is there to handle the entire eviction process.",
      options: ['Up To 3 Months Of Rent Included', 'Unavailable'],
    },
    item1Nationally: {
      name: 'Guaranteed Rent & Eviction Protection',
      text: "We're so confident in our vetting process, that once we place Residents in your home, their rent payments are guaranteed regardless of if we’re able to collect. And while situations can change, even for the best of Residents, Belong is there to handle the entire eviction process.",
      options: ['Included', 'Unavailable'],
    },
    item2: {
      name: 'Management Fee',
      options: ['', '8‑12% Of Rent'],
    },
    item3: {
      name: 'Placement Fee',
      options: ['', '100% Of 1st Month’s Rent'],
    },
    item4: {
      name: 'Lease Renewal Fee',
      options: ['', '$200‑1k'],
    },
  },
  item1: {
    name: 'Guaranteed Time To Rent',
    text: 'From the moment homes are listed, Belong gets homes rented in an average of 21 days. We will guarantee yours will be loved in less than 45 days.',
    options: ['Included', 'Unavailable'],
  },
  item2: {
    name: '30k+ Maintenance Pros In Network',
    text: 'Whether your home needs handiwork, a fresh set of paint, or an emergency plumber, Belong has a Pro for that. They’re all vetted, licensed, bonded, insured, and competing, ensuring your home gets the very best quality of work, all at market rates.',
    options: ['Included', 'Unavailable'],
  },
  item3: {
    name: 'Best-In-Class Mobile App',
    text: 'Our app was designed from the ground up for Homeowners like you. Track earnings, communicate with your Homes’ team, review estimates, and approve work all on the app.',
    options: ['Included', 'Unavailable'],
  },
  item4: {
    name: 'Unique 360 Wealth Insights',
    text: 'Understanding the economics of renting can be challenging. Receive a full analysis that takes into consideration not only the income and expenses related to rental home management, but also important aspects like equity, appreciation, and dreaded taxes. Get the full picture of your long-term gains and monthly cash flow, and even compare your options.',
    options: ['Included', 'Unavailable'],
  },
  item5: {
    name: '24/7 & Emergency Support',
    text: 'The Belong Team is there for you and your Residents whenever you need us, at no additional cost.',
    options: ['Included', 'Unavailable'],
  },
  item6: {
    name: 'Initial Setup',
    options: ['FREE', '$200‑500'],
  },
  item7: {
    name: '280 Point Home Inspection',
    options: ['FREE', '$150'],
  },
  item8: {
    name: 'Data-Driven Pricing Analysis',
    options: ['FREE', '$100'],
  },
  item9: {
    name: 'Professional Photo Shoots',
    options: ['FREE', '$150‑500'],
  },
  item10: {
    name: '3D & Virtual Tours',
    options: ['FREE', '$250‑400'],
  },
  item11: {
    name: 'Photoshoots',
    options: ['FREE', '$500'],
  },
  item12: {
    name: 'Premium Advertising',
    options: ['FREE', '$100‑200'],
  },
  item13: {
    name: 'Move Coordination',
    options: ['FREE', '$100‑200'],
  },
  item14: {
    name: 'Tax Document Preparation',
    options: ['FREE', '$50‑150'],
  },
  item15: {
    name: 'Early Termination Fee',
    options: ['NONE', '1 Month Of Rent'],
  },
  item16: {
    name: 'Vacancy Fee',
    options: ['NONE', '$25‑100/Month'],
  },
  item17: {
    name: 'Legal Compliance Fee',
    options: ['NONE', '$50‑150/Year'],
  },
  item18: {
    name: 'Accounting / Administrative Fee',
    options: ['NONE', '$10‑50/Month'],
  },
  item19: {
    name: 'Insurance Claim Coordination Fee',
    options: ['NONE', '$100‑300/Claim'],
  },
};
